import type { SubdivisionCatalog } from "./types";

/**
 * Peru — **26 rows, not 25**. ISO defines 25 regions (24 departments plus El Callao) and then a 26th entry
 * for the Municipalidad Metropolitana de Lima, the capital province split off from the Lima region in 2002.
 * So "Lima" is two different places here, which is what `displayName` on `PE-LIM` exists to keep apart.
 */
export const PER_SUBDIVISIONS: SubdivisionCatalog = [
  { code: "PE-AMA", name: "Amazonas" },
  { code: "PE-ANC", name: "Ancash" },
  { code: "PE-APU", name: "Apurímac" },
  { code: "PE-ARE", name: "Arequipa" },
  { code: "PE-AYA", name: "Ayacucho" },
  { code: "PE-CAJ", name: "Cajamarca" },
  { code: "PE-CUS", name: "Cusco" },
  { code: "PE-CAL", name: "El Callao", aliases: ["Callao"] },
  { code: "PE-HUV", name: "Huancavelica" },
  { code: "PE-HUC", name: "Huánuco" },
  { code: "PE-ICA", name: "Ica" },
  { code: "PE-JUN", name: "Junín" },
  { code: "PE-LAL", name: "La Libertad" },
  { code: "PE-LAM", name: "Lambayeque" },
  // The region, which excludes the capital. `PE-LMA` below is the city.
  { code: "PE-LIM", name: "Lima", displayName: "Lima (departamento)" },
  { code: "PE-LOR", name: "Loreto" },
  { code: "PE-MDD", name: "Madre de Dios" },
  { code: "PE-MOQ", name: "Moquegua" },
  { code: "PE-LMA", name: "Municipalidad Metropolitana de Lima", aliases: ["Lima Metropolitana"] },
  { code: "PE-PAS", name: "Pasco" },
  { code: "PE-PIU", name: "Piura" },
  { code: "PE-PUN", name: "Puno" },
  { code: "PE-SAM", name: "San Martín" },
  { code: "PE-TAC", name: "Tacna" },
  { code: "PE-TUM", name: "Tumbes" },
  { code: "PE-UCA", name: "Ucayali" },
];
